<template>
  <div class="sidebar">
    <v-list class="d-md-none">
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <img src='/images/base/avatar.png'>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>{{ user ? user.first_name + ' ' + user.last_name : '' }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>

    <v-divider class="m-0 d-md-none"></v-divider>

    <template v-if="user">
      <v-list dense class="mt-2 pt-0" v-if="user.role === 3">
        <v-list-tile
          v-for="item in admin_items"
          :key="item.title"
          :to="{ name: item.name }"
          active-class="v-list__tile--highlighted"
        >
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>

      <v-list dense class="mt-2 pt-0" v-else-if="user.role === 2">
        <v-list-tile
          v-for="item in user_items"
          :key="item.title"
          :to="{ name: item.name }"
          active-class="v-list__tile--highlighted"
        >
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>

      <v-list dense class="mt-2 pt-0" v-else>
        <v-list-tile
          v-if="user.role == 1"
          v-for="item in affiliate_items"
          :key="item.title"
          :to="{ name: item.name }"
          active-class="v-list__tile--highlighted"
        >
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile
          v-if="user.affiliate_role == 1 && user.affiliate_status != 0"
          v-for="item in master_affiliate_items"
          :key="item.title"
          :to="{ name: item.name }"
          active-class="v-list__tile--highlighted"
        >
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
    </v-list>
    </template>

    <v-divider class="m-0"></v-divider>

    <v-list dense v-if="user">
      <v-list-tile
        :to="{ name: 'users' }"
        active-class="v-list__tile--highlighted"
        v-if="user.role === 3"
      >
        <v-list-tile-action>
          <v-icon>supervisor_account</v-icon>
        </v-list-tile-action>

        <v-list-tile-content>
          <v-list-tile-title>Users</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile
        :to="{ name: 'profile' }"
        active-class="v-list__tile--highlighted"
      >
        <v-list-tile-action>
          <v-icon>account_circle</v-icon>
        </v-list-tile-action>

        <v-list-tile-content>
          <v-list-tile-title>Profile</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>

    <v-list dense class="btn-logout d-md-none">
      <v-list-tile @click.prevent="logout">
        <v-list-tile-action>
          <v-icon>exit_to_app</v-icon>
        </v-list-tile-action>

        <v-list-tile-content>
          <v-list-tile-title>Logout</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {

    data: () => ({
      master_affiliate_items: [
        { name: 'affiliate-summaries', img: 'keep.png', title: 'Affiliate Summary', icon: 'view_compact' },
        { name: 'affiliate-payout-summaries', img: 'keep.png', title: 'Affiliate Payout Summary', icon: 'donut_large' }
      ],
      affiliate_items: [
        { name: 'summaries', img: 'keep.png', title: 'Summary', icon: 'trending_up' },
        { name: 'client-list', img: 'keep.png', title: 'Client List', icon: 'supervisor_account' },
        { name: 'affiliate-orders', img: 'keep.png', title: 'Orders', icon: 'adjust' }
      ],
      user_items: [
        { name: 'beta-users', img: 'keep.png', title: 'Beta Users', icon: 'supervisor_account' },
        { name: 'affiliates', img: 'keep.png', title: 'Affiliates', icon: 'supervisor_account' },
        { name: 'customers', img: 'keep.png', title: 'Customers', icon: 'verified_user' },
        { name: 'ambassadors', img: 'inbox.png', title: 'Ambassadors', icon: 'dashboard' },
        { name: 'out-stocks', img: 'inbox.png', title: 'Out Stocks', icon: 'add_shopping_cart' },
        { name: 'custom-orders', img: 'inbox.png', title: 'Custom Orders', icon: 'album' }
      ],
      admin_items: [
        { name: 'beta-users', img: 'keep.png', title: 'Beta Users', icon: 'supervisor_account' },
        { name: 'affiliates', img: 'keep.png', title: 'Affiliates', icon: 'supervisor_account' },
        { name: 'orders', img: 'keep.png', title: 'Orders', icon: 'adjust' },
        { name: 'customers', img: 'keep.png', title: 'Customers', icon: 'verified_user' },
        { name: 'ambassadors', img: 'inbox.png', title: 'Ambassadors', icon: 'dashboard' },
        { name: 'out-stocks', img: 'inbox.png', title: 'Out Stocks', icon: 'add_shopping_cart' },
        { name: 'custom-orders', img: 'inbox.png', title: 'Custom Orders', icon: 'album' }
      ]
    }),

    computed: mapGetters({
      user: 'auth/user'
    }),

    methods: {
      async logout () {
        // Log out the user.
        await this.$store.dispatch('auth/logout')

        // Redirect to login.
        this.$router.push({ name: 'login' })
      }
    }
  }
</script>

<style>
  .theme--light.v-list .v-list__tile--link,
  .theme--light.v-list .v-list__tile--link:hover,
  .md-theme-default a:not(.md-button) {
    color: rgba(0,0,0,.87);
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// resources/js/components/Sidebar.vue